import moment from "moment"
import { RowExportTypeExcel } from "types"
import { excel } from "utils"
import { CountList } from "../../ItemCount/type"
import { PropsWithChildren } from "react"
import { numberFormat } from "../utils"
import { TableSorting } from "components"

type ExportCountType = {
  data: CountList[],
  filter: {
    dateFrom: string | undefined,
    dateTo: string | undefined
  },
  module?: string,
  title: string,
  fileName: string
  activeColumns: TableSorting[]
}
enum COUNT_STATUS {
  COUNT = 1,
  ADJUSTMENT = 2,
}


export function ExportExcelCount(props: PropsWithChildren<ExportCountType>) {
const activeCols = props.activeColumns.filter(col => col.isActive !== false)

  const columns = [
    { header: "NO", key: "no", width: 5 },
    ...activeCols
      .map(col => renderColumn(col.value as string))
      .filter((col): col is NonNullable<typeof col> => col !== undefined),
  ]

  const dataMap = props.data.map((item, index) => {
    const row: Record<string, any> = { no: index + 1 }

    activeCols.forEach(col => {
      const colMeta = renderColumn(col.value as string)
      if (colMeta) {
        row[colMeta.key] = renderCellValue(col.value as string, item)
      }
    })

    return row
  })

  excel({
    dataList: dataMap,
    column: columns,
    module: props.module,
    title: props.title,
    fileName: props.fileName,
    date: `${moment(props.filter.dateFrom).format('DD-MM-YYYY')} - ${moment(props.filter.dateTo).format('DD-MM-YYYY')}`
  })
}

function renderColumn(title: string): { header: string; key: string | number; width: number } | undefined {
  const map: Record<string, { header: string; key: keyof RowExportTypeExcel; width: number }> = {
    "trx_code": { header: "COUNT ID#", key: "trx_code", width: 20 },
    "transaction_date": { header: "DATE", key: "transaction_date", width: 15 },
    "location_name": { header: "LOCATION", key: "location_name", width: 15 },
    "employee_name": { header: "TRADER", key: "employee_name", width: 30 },
    "status": { header: "STATUS", key: "count_status", width: 15 },
    "memo": { header: "MEMO", key: "memo", width: 30 },
    "soh": { header: "SOH", key: "soh", width: 15 },
    "count": { header: "COUNT", key: "real_count", width: 15 },
    "difference": { header: "DIFFERENCE", key: "different", width: 15 },
  }
  return map[title]
}


function renderCellValue(title: string, item: any): any {
  switch (title) {
    case "trx_code":
      return item.trx_code
    case "transaction_date":
      return moment(item.transaction_date).format("DD/MM/YYYY")
    case "location_name":
      return item.location_name
    case "employee_name":
      return item.employee_name
    case "status":
      return COUNT_STATUS[item.count_status]
    case "memo":
      return item.memo
    case "soh":
      return numberFormat(Number(item.soh))
    case "count":
      return numberFormat(Number(item.real_count))
    case "difference":
      return numberFormat(Number(item.different))
    default:
      return item
  }
}

